import { FunctionComponent, memo } from "react";
import { Form, Formik } from "formik";
import { faEnvelopeCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { Button, FieldError } from "@edgetier/components";
import { IFormValues, IProps } from "./users-subscribed-form.types";
import * as Yup from "yup";
import SelectUser from "components-for/filters/select-user";
import "./users-subscribed-form.scss";

/**
 * A form for subscribing users to tag alerts
 * @param props.onSubscribe
 */
const UsersSubscribedForm: FunctionComponent<IProps> = ({ onSubscribe }) => {
    const onSubmit = (values: IFormValues) => {
        onSubscribe(values.userId);
    };

    return (
        <Formik<IFormValues>
            initialValues={{ userId: [] }}
            validationSchema={Yup.object().shape({
                userId: Yup.array().of(Yup.string()),
            })}
            onSubmit={onSubmit}
        >
            {({ isSubmitting, values }) => (
                <Form autoComplete="off" name="userForm">
                    <div className="field">
                        <FieldError name="userId" />
                        <label htmlFor="modelIds">Users</label>
                        <SelectUser name="userId" isFilter={false} isMedium />
                    </div>
                    <Button
                        type="submit"
                        disabled={values.userId.length === 0}
                        isLoading={isSubmitting}
                        icon={faEnvelopeCircleCheck}
                    >
                        Subscribe
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default memo(UsersSubscribedForm);
